export default "__VITE_ASSET__6J_eIQo7__"